
import { Vue, Component } from "vue-property-decorator";
import PageSection from "@/components/Common/PageSection.vue";

@Component({ components: { PageSection } })
export default class NotFound extends Vue {}
